// extracted by mini-css-extract-plugin
export default {"profile_heading":"WorkSpace_profile_heading__bFB-h","profile_info":"WorkSpace_profile_info__Dh36W","profile_item":"WorkSpace_profile_item__l9cKN"};